/** Format a number as "1,234.50" (prefix with "RM " when displaying). Currency is always MYR. */
export function formatMyr(value) {
  return parseFloat(value || 0).toLocaleString('en-MY', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
}
